!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactKeyHandler = t(require("react")) : e.ReactKeyHandler = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.KEYDOWN = "keydown", t.KEYPRESS = "keypress", t.KEYUP = "keyup";
  }, function (e, t, n) {
    "use strict";

    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.keyToggleHandler = t.keyHandler = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        u = n(0);

    Object.keys(u).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return u[e];
        }
      });
    });
    var a = f(n(3)),
        i = f(n(4)),
        c = n(7),
        l = n(8);

    function f(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function s(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function d(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function p(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var y = function (e) {
      function t(e) {
        s(this, t);
        var n = d(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.handleKey = function (e) {
          var t = n.props,
              r = t.keyValue,
              o = t.keyCode,
              u = t.onKeyHandle;

          if (u) {
            var a = e.target;
            a instanceof window.HTMLElement && (0, l.isInput)(a) || (0, l.matchesKeyboardEvent)(e, {
              keyValue: r,
              keyCode: o
            }) && u(e);
          }
        }, e.keyValue || e.keyCode || console.error("Warning: Failed propType: Missing prop `keyValue` or `keyCode` for `KeyHandler`."), n;
      }

      return p(t, a.default.Component), o(t, [{
        key: "shouldComponentUpdate",
        value: function value() {
          return !1;
        }
      }]), o(t, [{
        key: "componentDidMount",
        value: function value() {
          c.canUseDOM && window.document.addEventListener(this.props.keyEventName, this.handleKey);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          c.canUseDOM && window.document.removeEventListener(this.props.keyEventName, this.handleKey);
        }
      }, {
        key: "render",
        value: function value() {
          return null;
        }
      }]), t;
    }();

    function v(e) {
      return function (t) {
        var n = t || {},
            u = n.keyValue,
            i = n.keyCode,
            c = n.keyEventName,
            f = function (e, t) {
          var n = {};

          for (var r in e) {
            t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
          }

          return n;
        }(n, ["keyValue", "keyCode", "keyEventName"]);

        return function (t) {
          return function (n) {
            function v() {
              var t, n, r;
              s(this, v);

              for (var o = arguments.length, u = Array(o), a = 0; a < o; a++) {
                u[a] = arguments[a];
              }

              return n = r = d(this, (t = v.__proto__ || Object.getPrototypeOf(v)).call.apply(t, [this].concat(u))), r.state = {
                keyCode: null,
                keyValue: null
              }, r.handleKey = function (t) {
                e && e(t, r.state) ? r.setState({
                  keyValue: null,
                  keyCode: null
                }) : r.setState({
                  keyValue: (0, l.eventKey)(t),
                  keyCode: t.keyCode
                });
              }, d(r, n);
            }

            return p(v, a.default.Component), o(v, [{
              key: "render",
              value: function value() {
                return a.default.createElement("div", null, a.default.createElement(y, {
                  keyValue: u,
                  keyCode: i,
                  keyEventName: c,
                  onKeyHandle: this.handleKey
                }), a.default.createElement(t, r({}, f, this.state)));
              }
            }]), v;
          }();
        };
      };
    }

    y.propTypes = {
      keyValue: i.default.string,
      keyCode: i.default.number,
      keyEventName: i.default.oneOf([u.KEYDOWN, u.KEYPRESS, u.KEYUP]),
      onKeyHandle: i.default.func
    }, y.defaultProps = {
      keyEventName: u.KEYUP
    }, t.default = y;
    t.keyHandler = v(), t.keyToggleHandler = v(l.matchesKeyboardEvent);
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(5)();
  }, function (e, t, n) {
    "use strict";

    var r = n(6);

    function o() {}

    e.exports = function () {
      function e(e, t, n, o, u, a) {
        if (a !== r) {
          var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw i.name = "Invariant Violation", i;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    var r;
    /*!
      Copyright (c) 2015 Jed Watson.
      Based on code that is Copyright 2013-2015, Facebook, Inc.
      All rights reserved.
    */

    /*!
      Copyright (c) 2015 Jed Watson.
      Based on code that is Copyright 2013-2015, Facebook, Inc.
      All rights reserved.
    */

    !function () {
      "use strict";

      var o = !("undefined" == typeof window || !window.document || !window.document.createElement),
          u = {
        canUseDOM: o,
        canUseWorkers: "undefined" != typeof Worker,
        canUseEventListeners: o && !(!window.addEventListener && !window.attachEvent),
        canUseViewport: o && !!window.screen
      };
      void 0 === (r = function () {
        return u;
      }.call(t, n, t, e)) || (e.exports = r);
    }();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isInput = function (e) {
      if (!e) return !1;

      var t = e.tagName,
          n = function (e) {
        if ("function" != typeof e.getAttribute) return !1;
        return !!e.getAttribute("contenteditable");
      }(e);

      return "INPUT" === t || "TEXTAREA" === t || n;
    }, t.matchesKeyboardEvent = function (e, t) {
      var n = t.keyCode,
          r = t.keyValue;
      if (!a(r)) return r === i(e);

      if (!a(n)) {
        var o = e.keyCode || e.which;
        return n === o;
      }

      return !1;
    }, t.eventKey = i;
    var r = n(0),
        o = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
        u = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };

    function a(e) {
      return void 0 === e || null === e;
    }

    function i(e) {
      var t = e.key,
          n = e.keyCode,
          a = e.type;

      if (t) {
        var i = o[t] || t;
        if ("Unidentified" !== i) return i;
      }

      if (a === r.KEYPRESS) {
        var c = function (e) {
          var t = e.charCode,
              n = e.keyCode;

          if ("charCode" in e) {
            if (0 === t && 13 === n) return 13;
          } else t = n;

          if (t >= 32 || 13 === t) return t;
          return 0;
        }(e);

        return 13 === c ? "Enter" : String.fromCharCode(c);
      }

      return a === r.KEYDOWN || a === r.KEYUP ? u[String(n)] || "Unidentified" : "";
    }
  }]);
});